import React, { useCallback, useEffect, useRef, useState } from 'react';
import CashSettings from './CashSettings';
import CashAdminDeposits from './CashAdminDeposits';
import CashDisputeControl from './CashDisputeControl';
import CashFundingRecovery from './CashFundingRecovery';
export default function CashAdminWorkspace({
  distributorId,
  disabled,
  onLockChange,
  onBankChange,
}) {
  const [settingsLocked, setSettingsLocked] = useState(false),
    [reviewLocked, setReviewLocked] = useState(false),
    [disputeLocked, setDisputeLocked] = useState(false),
    [recoveryLocked, setRecoveryLocked] = useState(false);
  const callback = useRef(onLockChange);
  callback.current = onLockChange;
  const settingsChange = useCallback((value) => setSettingsLocked(value), []);
  const reviewChange = useCallback((value) => setReviewLocked(value), []);
  const disputeChange = useCallback((value) => setDisputeLocked(value), []);
  const recoveryChange = useCallback((value) => setRecoveryLocked(value), []);
  useEffect(() => {
    callback.current?.(settingsLocked || reviewLocked || disputeLocked || recoveryLocked);
    return () => callback.current?.(false);
  }, [settingsLocked, reviewLocked, disputeLocked, recoveryLocked]);
  return (
    <>
      <CashSettings
        distributorId={distributorId}
        disabled={disabled || reviewLocked || disputeLocked || recoveryLocked}
        onLockChange={settingsChange}
      />
      <CashAdminDeposits
        distributorId={distributorId}
        disabled={disabled || settingsLocked || disputeLocked || recoveryLocked}
        onLockChange={reviewChange}
        onFundsChanged={onBankChange}
      />
      <CashFundingRecovery
        distributorId={distributorId}
        disabled={settingsLocked || reviewLocked || disputeLocked}
        onLockChange={recoveryChange}
        onUpdated={onBankChange}
      />
      <CashDisputeControl
        distributorId={distributorId}
        // A legacy recovery outage must not prevent an emergency manual spending hold.
        disabled={settingsLocked || reviewLocked}
        onLockChange={disputeChange}
        onUpdated={onBankChange}
      />
    </>
  );
}
